<div class="bg-white br-8 overflow-hidden bgcover box-shadow" [style.background-image]="'url(' + booking.cover_photo + ')'">
  <div class="d-flex flex-column h-100 px-4 py-3 w-100 text-white br-8">

    <div class="d-flex align-items-center w-100 justify-content-between">
      <span class="font-16 semi-bold">Réservation #{{booking.id}}</span>
      <button class="btn border-0 p-0 lightGray2 fw-light text-underlined w-fit-content font-12" (click)="leaveNote(noteModale)" *ngIf="!previewOnly">
        {{booking.note ? 'Modifier la note' : 'Laisser une note'}}
      </button>
    </div>
    <span class="font-12 semi-bold" *ngIf="!previewOnly">En attente de traitement</span>

    <span class="mt-auto semi-bold font-16">{{booking.property && booking.property.name != 'ZZZ' ? booking.property.name: 'N/A'}}</span>
    <span class="semi-bold font-16">{{booking.property ? booking.property.partner_ref: 'N/A'}}</span>

    <div class="w-100 d-flex align-items-center justify-content-between">
      <span class="font-14 fw-light">{{ booking.property && booking.property.city ? (booking.property.city + ' (' + booking.property.postal_code + ')') : 'N/A' }}</span>

      <mat-chip-listbox aria-label="Webinar tags" class="webinar-tags">
        <mat-chip-option class="font-12 text-nowrap semi-bold">{{booking.property && booking.property.partner && booking.property.partner.name != 'ZZZ' ? booking.property.partner.name : 'Partenaire inconnu' }}</mat-chip-option>
      </mat-chip-listbox>
    </div>

  </div>
</div>


<ng-template #noteModale let-modal>
  <div class="mt-5 px-4 d-flex align-items-center">
    <h5 class="font-trueno-bold font-28 fw-bold">Laisser une note</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="sendNote()" class="pb-4 mt-2 px-4 pt-2">
    <textarea name="content" id="content" cols="30" rows="4" class="form-control" formControlName="content"></textarea>

    <button class="btn btn-primary mt-4 w-100" (click)="sendNote()" [disabled]="isSending">
      <span *ngIf="isSending" class="spinner-border spinner-border-sm v-middle"></span>
      Sauvegarder la note
    </button>
  </form>



</ng-template>
